import { parseFilename } from './files';
import axios from 'axios';
import { HR_CONSOLIDATOR_BASE_URL } from '../constants';

export { downloadBlob } from './files';

export interface HrConsolidatorFiles {
  payRegisterFile: File;
  newJoineeFile: File;
  educationFile: File;
  previousMonthFile?: File | null;
  exitRecordFile?: File | null;
}

export interface HrConsolidatorOptions {
  outputFilename?: string;
  overrides?: Record<string, unknown>;
}

interface HrConsolidatorOptionsPayload {
  output_filename?: string;
  overrides?: Record<string, unknown>;
}

export interface HrConsolidatorResult {
  blob: Blob;
  filename: string;
}

export async function generateHrConsolidation(
  files: HrConsolidatorFiles,
  options?: HrConsolidatorOptions
): Promise<HrConsolidatorResult> {
  const formData = new FormData();
  formData.append('pay_register_file', files.payRegisterFile);
  formData.append('new_joinee_file', files.newJoineeFile);
  formData.append('education_file', files.educationFile);
  if (files.previousMonthFile) {
    formData.append('previous_month_file', files.previousMonthFile);
  }
  if (files.exitRecordFile) {
    formData.append('exit_record_file', files.exitRecordFile);
  }

  const optionsPayload: HrConsolidatorOptionsPayload = {};
  if (options?.outputFilename && options.outputFilename.trim()) {
    optionsPayload.output_filename = options.outputFilename.trim();
  }
  if (options?.overrides && Object.keys(options.overrides).length > 0) {
    optionsPayload.overrides = options.overrides;
  }
  if (Object.keys(optionsPayload).length > 0) {
    formData.append('options', JSON.stringify(optionsPayload));
  }

  try {
    const response = await axios.post(
      `${HR_CONSOLIDATOR_BASE_URL}/hr-consolidator/generate`,
      formData,
      { responseType: 'blob' }
    );

    const blob = response.data as Blob;
    const filename = parseFilename(
      response.headers['content-disposition'] || null,
      options?.outputFilename || 'HR_Consolidated.xlsx'
    );

    return { blob, filename };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const errorBlob = error.response?.data as Blob | undefined;
      const contentType = String(error.response?.headers?.['content-type'] || '');
      const data =
        errorBlob && contentType.includes('application/json')
          ? JSON.parse(await errorBlob.text())
          : null;
      const message =
        (data && data.detail) || `Consolidation failed with status ${error.response?.status}`;
      throw new Error(message);
    }
    throw error;
  }
}
